import { Box } from "@mui/material";
import Header from "../../components/Header";
import SalesTrend from "../../components/SalesTrend";

const Line = () => {
  return (
    <Box m="20px">
      <Header
        title="SALES TREND"
        subtitle="Visualise your sales trend data here"
      />
      <Box height="75vh">
        <SalesTrend />
      </Box>
    </Box>
  );
};

export default Line;
